import { IonIcon } from '@ionic/react';
import { shieldHalfOutline } from 'ionicons/icons';
import { withAvatarCacheBuster } from '../../lib/avatarUrl';
import { cn } from '../../lib/utils';

interface LeagueImageProps {
  image?: string | null;
  /** League's updatedAt, used to cache-bust the image after a re-upload. */
  updatedAt?: string | null;
  name?: string | null;
  /** Rendered size in pixels (width = height). */
  size?: number;
  className?: string;
  /** `onDark` renders the fallback shield in white for navy backgrounds. */
  variant?: 'default' | 'onDark';
}

/**
 * Circular league picture. Leagues without an image show the shield icon,
 * which is the single source of that fallback across the app.
 */
export const LeagueImage = ({
  image,
  updatedAt,
  name,
  size = 48,
  className,
  variant = 'default',
}: LeagueImageProps) => {
  const src = withAvatarCacheBuster(image, updatedAt);
  const label = name ? `Imagen de la liga ${name}` : 'Imagen de la liga';

  if (src) {
    return (
      <div
        className={cn('shrink-0 overflow-hidden rounded-full', className)}
        style={{ width: size, height: size }}
      >
        <img src={src} alt={label} className="h-full w-full object-cover" />
      </div>
    );
  }

  const onDark = variant === 'onDark';
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full',
        onDark && 'bg-white/15',
        className
      )}
      style={{ width: size, height: size }}
    >
      <IonIcon
        icon={shieldHalfOutline}
        color={onDark ? undefined : 'primary'}
        aria-label={label}
        data-testid="league-image-fallback"
        style={{ fontSize: Math.round(size * (onDark ? 0.6 : 1)), color: onDark ? '#ffffff' : undefined }}
      />
    </div>
  );
};
